class Dom {
  constructor(selector) {
    this.$el = typeof selector === "string" ? document.querySelector(selector) : selector;
  }

  // get & set Установить или Получить содержимое элемента DOM
  html(html) {
    if (typeof html === "string") {
      if (!!this.$el) {
        this.$el.innerHTML = html;
      }
      return this;
    }
    return this.$el.outerHTML.trim();
  }
  id(id) {
    if (typeof id === "string") {
      this.$el.id = id;
      return this;
    }
    return this.$el.id;
  }

  // Очистить содержимое элемента DOM
  clear() {
    this.html("");
    return this;
  }

  // Вставить элемент DOM в элемент DOM
  append(node) {
    if (node instanceof Dom) {
      node = node.$el;
    }
    this.$el.appendChild(node);
    return this;
  }
  on(eventType, callback, el) {
    el.addEventListener(eventType, callback);
  }
  off(eventType, callback, el) {
    el.removeEventListener(eventType, callback);
  }
}
export function $(selector) {
  return new Dom(selector);
}
$.create = function (tagName) {
  let classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const el = document.createElement(tagName);
  if (typeof classes === "string") {
    el.classList.add(classes);
  } else if (Array.isArray(classes)) {
    classes.forEach(x => {
      el.classList.add(x);
    });
  }
  return $(el);
};